import { Box, Collapse, IconButton, Stack, Typography } from "@mui/material";
import FAQAddIcon from "../../../UI/FAQAddIcon";
import { useEffect, useRef, useState } from "react";

function FAQCard() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle click inside
  const handleClick = () => {
    setOpen(!open);
  };

  // Handle click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <Stack
      ref={dropdownRef}
      sx={{
        border: "1px solid #A7A7A7",
        borderRadius: "30px",
        justifySelf: "start",
        minWidth: "550px",
        p: "20px",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography
          variant="body2"
          sx={{
            fontSize: "28px",
            lineHeight: "24px",
            color: "#0E0B33",
            fontFamily: "Inter",
            fontWeight: "700",
          }}
        >
          How do I search for jobs on Pitchers?
        </Typography>
        <IconButton
          sx={{ p: "0px", transform: open ? "rotate(45deg)" : "none" }}
          onClick={handleClick}
        >
          <FAQAddIcon />
        </IconButton>
      </Box>

      <Collapse
        in={open}
        timeout="auto"
        // sx={{
        //   pb: open ? "20px" : "",
        // }}
      >
        {" "}
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            lineHeight: "22px",
            color: "#0E0B33",
            fontFamily: "Inter",
            fontWeight: "400",
            width: "580px",
            pt: "4px",
          }}
        >
          To search for jobs on Pitchers, simply navigate to the homepage and
          enter your search criteria in the search bar at the top of the page.
          You can enter keywords related to the type of job you're looking for,
          as well as location and other filters such as job type or salary
          range. After that, click the Search button to begin your job hunting
          journey.
        </Typography>
      </Collapse>
    </Stack>
  );
}

export default FAQCard;
